module.exports = __webpack_public_path__ + "static/fatherChild-c106f03cd0f72fcc3d8edd9cfbbc8b43.png";